import AllToggle from '@components/Toggles/AllToggle';
import InterviewerCameraToggle from '@components/Toggles/CameraToggle/Interviewer';
import ContentShareToggle from '@components/Toggles/ContentShareToggle';
import ExitToggle from '@components/Toggles/ExitToggle';
import MicToggle from '@components/Toggles/MicToggle';
import RestartToggle from '@components/Toggles/RestartToggle';
import SpeakerToggle from '@components/Toggles/SpeakerToggle';
import type { FC } from 'react';
import { Container } from './style';

const InterviewerFeatureController: FC = () => {
  return (
    <Container>
      <ContentShareToggle />
      <MicToggle />
      <InterviewerCameraToggle />
      <SpeakerToggle />
      <AllToggle />
      <RestartToggle />
      <ExitToggle />
    </Container>
  );
};

export default InterviewerFeatureController;
